module.exports = __webpack_public_path__ + "static/geoff-b31f158a412429bec8f3124c79e6b7fe.png";